import {
  Box,
  Button,
  Divider,
  Drawer,
  Stack,
  Typography,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../../static/media/logo.webp";

const SIDEBAR_WIDTH = 260;

export default function Sidebar({
  mobileOpen,
  onClose,
  user,
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigate = (path) => {
    navigate(path);
    onClose?.();
  };

  const handleLogout = () => {
    localStorage.removeItem("admin_access_token");
    localStorage.removeItem("admin_refresh_token");
    localStorage.removeItem("admin_user");

    onClose?.();
    navigate("/admin-panel/login", { replace: true });
  };

  const isActive = (path) => {
    if (path === "/admin-panel") {
      return location.pathname === "/admin-panel";
    }

    return location.pathname.startsWith(path);
  };

  const menuButtonStyles = (path) => {
    const active = isActive(path);

    return {
      minHeight: 46,
      justifyContent: "flex-start",
      paddingX: 2,
      borderRadius: 1.5,
      color: "#ffffff",
      fontSize: 14,
      fontWeight: 800,
      textTransform: "none",
      backgroundColor: active ? "#b00020" : "transparent",
      border: "1px solid",
      borderColor: active ? "#b00020" : "transparent",
      "&:hover": {
        backgroundColor: active
          ? "#92001a"
          : "rgba(255,255,255,0.08)",
        borderColor: active
          ? "#92001a"
          : "rgba(255,255,255,0.12)",
      },
    };
  };

  const content = (
    <Box
      sx={{
        width: SIDEBAR_WIDTH,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#000000",
        color: "#ffffff",
        padding: 2.5,
      }}
    >
      <Stack
        direction="row"
        spacing={1.5}
        alignItems="center"
      >
        <Box
          component="img"
          src={logo}
          alt="AccessHub"
          sx={{
            width: 50,
            height: 50,
            objectFit: "contain",
            flexShrink: 0,
          }}
        />

        <Box sx={{ minWidth: 0 }}>
          <Typography
            sx={{
              fontSize: 18,
              fontWeight: 800,
              lineHeight: 1.2,
            }}
          >
            AccessHub
          </Typography>

        </Box>
      </Stack>

      <Divider
        sx={{
          marginY: 3,
          borderColor: "rgba(255,255,255,0.14)",
        }}
      />

      <Stack spacing={0.8}>
        <Button
          variant="text"
          onClick={() => handleNavigate("/admin-panel")}
          sx={menuButtonStyles("/admin-panel")}
        >
          Inicio
        </Button>

        <Button
          variant="text"
          onClick={() =>
            handleNavigate("/admin-panel/tenants")
          }
          sx={menuButtonStyles("/admin-panel/tenants")}
        >
          Organizaciones
        </Button>
      </Stack>

      <Box sx={{ flexGrow: 1 }} />

      <Box
        sx={{
          marginBottom: 2,
          paddingTop: 2,
          borderTop: "1px solid rgba(255,255,255,0.14)",
        }}
      >
        <Typography
          sx={{
            color: "#ffffff",
            fontSize: 13,
            fontWeight: 800,
            wordBreak: "break-word",
          }}
        >
          {user?.name || "Superadministrador"}
        </Typography>

        <Typography
          sx={{
            marginTop: 0.4,
            color: "#9ca3af",
            fontSize: 11,
            fontWeight: 700,
            wordBreak: "break-word",
          }}
        >
          {user?.email || ""}
        </Typography>
      </Box>

      <Button
        variant="contained"
        onClick={handleLogout}
        disableElevation
        sx={{
          minHeight: 46,
          justifyContent: "flex-start",
          paddingX: 2,
          borderRadius: 1.5,
          color: "#ffffff",
          backgroundColor: "#dc2626",
          fontSize: 14,
          fontWeight: 800,
          textTransform: "none",
          "&:hover": {
            backgroundColor: "#b91c1c",
          },
        }}
      >
        Cerrar sesión
      </Button>
    </Box>
  );

  return (
    <>
      <Box
        component="aside"
        sx={{
          width: SIDEBAR_WIDTH,
          flexShrink: 0,
          display: {
            xs: "none",
            md: "block",
          },
        }}
      >
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: SIDEBAR_WIDTH,
            height: "100vh",
          }}
        >
          {content}
        </Box>
      </Box>

      <Drawer
        open={mobileOpen}
        onClose={onClose}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: {
            xs: "block",
            md: "none",
          },
          "& .MuiDrawer-paper": {
            width: SIDEBAR_WIDTH,
            border: 0,
            backgroundColor: "#000000",
          },
        }}
      >
        {content}
      </Drawer>
    </>
  );
}